module.exports = __webpack_public_path__ + "img/type10090.5bb58f52.png";